import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface the crash so it stops being a silent black screen.
    console.error("[Cehnura] UI crash:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/dashboard";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || "Une erreur inattendue est survenue.";
    return (
      <div
        data-testid="app-error-boundary"
        className="min-h-screen bg-[#0A0A0C] text-zinc-100 flex items-center justify-center px-6"
      >
        <div className="w-full max-w-md text-center">
          <div className="mx-auto mb-5 w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
            <span className="text-2xl">⚠️</span>
          </div>
          <h1 className="font-display text-2xl font-extrabold">Oups, un souci est survenu</h1>
          <p className="text-sm text-zinc-400 mt-2">
            Cette page n'a pas pu s'afficher correctement. Tu peux revenir à ton tableau de bord.
          </p>
          <p className="text-xs text-zinc-600 mt-3 break-words font-mono">{msg}</p>
          <div className="mt-6 flex flex-col gap-2">
            <button
              onClick={this.handleReload}
              data-testid="error-reload-btn"
              className="h-12 rounded-2xl gold-gradient text-black font-semibold"
            >
              Retour au tableau de bord
            </button>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-refresh-btn"
              className="h-11 rounded-2xl bg-zinc-900 border border-zinc-800 text-sm text-zinc-300"
            >
              Recharger la page
            </button>
          </div>
        </div>
      </div>
    );
  }
}
